import { styles } from '@signavio/ui';
import useMatchMedia from './useMatchMedia';
export function useIsXS() {
  return useMatchMedia(styles.media.getSizeMediaQuery({
    xs: true
  }));
}
export function useIsSM() {
  return useMatchMedia(styles.media.getSizeMediaQuery({
    sm: true
  }));
}
export function useIsMD() {
  return useMatchMedia(styles.media.getSizeMediaQuery({
    md: true
  }));
}
export function useIsLG() {
  return useMatchMedia(styles.media.getSizeMediaQuery({
    lg: true
  }));
}